import React from 'react';
import { Navigate } from 'react-router-dom';
import { CarDetail } from 'containers/CarDetail';

import {
  CarPictures,
  CarSegments,
  Dashboard,
  ImageViewer,
  InspectionDetail,
  Login,
  NotFoundPage,
  ServerErrorPage,
} from '../containers';
import { routes } from '../utils/routeConfig';

const authProtectedRoutes = [
  // Dashboard
  { path: routes.dashboard, component: Dashboard },
  { path: routes.carSegments, component: CarSegments },
  { path: routes.carDetails, component: CarDetail },
  { path: routes.segmentDetail, component: InspectionDetail },
  { path: routes.carPictures, component: CarPictures },
  { path: routes.documents, component: CarPictures },
  { path: routes.imageViewer, component: ImageViewer },

  // this route should be at the end of all others routes
  { path: '/', exact: true, component: () => <Navigate to={routes.dashboard} replace={true} /> },
  { path: '*', exact: true, component: NotFoundPage },
];

const publicRoutes = [{ path: routes.login, component: Login }];

export { authProtectedRoutes, publicRoutes };
